import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';
import AuditLogPanel from './AuditLogPanel';

/** Full change history of one player (settings, balance, logins, system resets). */
const PlayerHistoryModal = ({ isOpen, onClose, username, playerId }) => {
  const targets = [username, playerId].filter(Boolean).map(String);
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>History — {username || playerId}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {isOpen && targets.length > 0 && (
            <AuditLogPanel
              exactTargets={targets}
              defaultDays={0}
              compact
              exportName={`player-${username || playerId}-history`}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PlayerHistoryModal;
